import React from "react";
import "./Ambitiousfuture.css";
import crystalball from "../../Media/crystalball.svg";

const Ambitiousfuture = () => {
  return (
    <section className="building-ambitious-future">
      <div className="building-ambitious-future-content-one">
        <h2 className="building-ambitious-future-content-one-text who-we-are-animate">
          Building Ambitious Future
        </h2>
      </div>
      <div className="building-ambitious-future-content-two">
        <p className="building-ambitious-future-content-two-text who-we-are-animate">
          Through Innovation and collective knowledge Althi Solutions is an IT
          services, consulting, and business solutions organization. We serve
          both big and small businesses in various industries such as
          manufacturing, healthcare, finance, education, etc.
        </p>
      </div>
      <div className="building-ambitious-future-content-three">
        <img
          className="building-ambitious-future-content-three-image crystal-ball-animate"
          src={crystalball}
          alt="Illustration representing future innovation and vision"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default Ambitiousfuture;
